
import { Vue } from 'vue-property-decorator';

export default class SkeletonInvoiceReceipts extends Vue {
}
